import angular from 'angular';

import Component from './ZoneSelection.component';
import ZoneSelectionPolyService from './ZoneSelectionPolyService';
import ZoneSelectionRectService from './ZoneSelectionRectService';
import Store from './ZoneSelection.store';

export default angular
  .module('petroCloud.dashboard.cameraPanel.zoneSelection', [])
  .component(Component.name, Component)
  .service('ZoneSelectionPolyService', ZoneSelectionPolyService)
  .service('ZoneSelectionRectService', ZoneSelectionRectService)
  .value(Store.name, Store)
  .name;
